import { useState } from "react";
import { toast } from "sonner";
import { Loader2, PenLine } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { FirmaPad } from "./FirmaPad";

// Formulario de firma del cliente (página pública del enlace y portal del cliente).
export const FirmaClienteForm = ({ v, onFirmar }) => {
  const [d, setD] = useState({ nombre: v.cliente?.nombre || "", dni: v.cliente?.dni || "", firma: "", acepto: false, inicio_inmediato: false });
  const [busy, setBusy] = useState(false);
  const firmar = async () => {
    if (!d.acepto) { toast.error("Marca la casilla para confirmar que has leído y aceptas el contrato"); return; }
    if (!d.firma) { toast.error("Firma en el recuadro"); return; }
    setBusy(true);
    try { await onFirmar({ ...d, huella: v.huella }); }
    finally { setBusy(false); }
  };
  return (
    <section className="rounded-2xl border-2 border-[#00B4CC]/40 bg-white p-4 sm:p-6 space-y-4" data-testid="firma-cliente-form">
      <h2 className="flex items-center gap-2 font-bold text-[#1B2B4B]"><PenLine className="w-5 h-5 text-[#00B4CC]" /> Firma el contrato</h2>
      <div className="grid sm:grid-cols-2 gap-3">
        <div><Label className="text-xs">Nombre y apellidos</Label><Input value={d.nombre} onChange={(e) => setD({ ...d, nombre: e.target.value })} className="mt-1" data-testid="firma-cliente-nombre" /></div>
        <div><Label className="text-xs">DNI / NIE / NIF</Label><Input value={d.dni} onChange={(e) => setD({ ...d, dni: e.target.value })} className="mt-1" data-testid="firma-cliente-dni" /></div>
      </div>
      <FirmaPad onChange={(firma) => setD((x) => ({ ...x, firma }))} testid="firma-cliente-pad" />
      <label className="flex items-start gap-2.5 text-sm text-slate-700">
        <input type="checkbox" checked={d.acepto} onChange={(e) => setD({ ...d, acepto: e.target.checked })} className="mt-1" data-testid="firma-cliente-acepto" />
        He leído el contrato completo y acepto todas sus cláusulas.
      </label>
      {v.consumidor && (
        <label className="flex items-start gap-2.5 text-sm text-slate-700">
          <input type="checkbox" checked={d.inicio_inmediato} onChange={(e) => setD({ ...d, inicio_inmediato: e.target.checked })} className="mt-1" data-testid="firma-cliente-inicio" />
          <span>Quiero que los trabajos empiecen antes de que acaben los 14 días del derecho de desistimiento <span className="text-slate-400">(opcional)</span>.</span>
        </label>
      )}
      <Button onClick={firmar} disabled={busy} className="w-full h-12 rounded-xl bg-[#1B2B4B] hover:bg-[#13203A] text-white font-bold" data-testid="firma-cliente-enviar">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Firmar contrato"}
      </Button>
      <p className="text-[11px] text-slate-400">Al firmar se guardan la fecha y la hora, tu dirección IP y la huella digital del documento como prueba de la firma. Recibirás una copia en PDF por email.</p>
    </section>
  );
};
